
import { Component, Emit, Vue } from "vue-property-decorator";
import { Nullable, Address, PointOfContact } from "@gsx/common";
import FormSelect from "../../../form/FormSelect.vue";
import FormCheckbox from "../../../form/FormCheckbox.vue";
import FormLabel from "../../../form/FormLabel.vue";
import FormInput from "../../../form/FormInput.vue";
import ActionButton from "../../../../../../common/src/components/ActionButton.vue";
import Modal from "../../../../../../common/src/components/Modal.vue";
import FormTel from "../../../form/FormTel.vue";
import FormTextarea from "../../../form/FormTextarea.vue";
import AddAddressModal from "../address/AddAddressModal.vue";
import EditAddressModal from "../address/EditAddressModal.vue";

@Component({
    components: {
        FormTextarea,
        FormTel,
        FormInput,
        FormCheckbox,
        FormLabel,
        ActionButton,
        FormSelect,
        Modal,
        AddAddressModal,
        EditAddressModal,
    },
})
export default class AddOrganizationPointOfContactModal extends Vue {
    firstName: string | null = null;
    lastName: string | null = null;
    phoneNumber: string | null = null;
    email: string | null = null;
    address: Address | null = null;
    title: string | null = null;
    publicInfo: boolean | null = null;

    isMainModalVisible = true;
    isAddAddressModalVisible = false;
    isEditAddressModalVisible = false;

    displayMainModal() {
        this.isMainModalVisible = true;
    }

    displayAddAddressModal() {
        this.hideMainModal();
        this.isAddAddressModalVisible = true;
    }

    hideMainModal() {
        this.isMainModalVisible = false;
    }

    hideAddAddressModal() {
        this.displayMainModal();
        this.isAddAddressModalVisible = false;
    }

    displayEditAddressModal() {
        this.hideMainModal();
        this.isEditAddressModalVisible = true;
    }

    hideEditAddressModal() {
        this.displayMainModal();
        this.isEditAddressModalVisible = false;
    }

    editAddress(address: Address) {
        this.address = address;
    }

    addAddress(address: Address) {
        this.address = address;
    }

    @Emit()
    submit(): Nullable<PointOfContact> {
        return {
            firstName: this.firstName,
            lastName: this.lastName,
            phoneNumber: this.phoneNumber,
            email: this.email,
            address: this.address,
            title: this.title,
            publicInfo: this.publicInfo,
        };
    }

    @Emit()
    close() {
        //
    }

    async onSubmit() {
        this.submit();
        this.close();
    }
}
